import { babyface } from '../CDNUrl';

const HOME_BANNER_URI = `${babyface}/home/home_banner`;

export const HOME_BANNER_CHRISTMAS = {
  src: `${HOME_BANNER_URI}_christmas_24.jpg`,
  alt: `크리스마스 이벤트 홈배너`,
};
